import React, { useState } from 'react';
import { Divider, Input, Select } from 'antd';
import { Form } from '..';
import Wrapper from './style';
import commonMessage from '../../configs/commonMessage';
import { RegionsHooks } from '../../hooks';

const { Option } = Select;

const Index = () => {
  const [provinceCode, setProvinceCode] = useState('');

  const { data: listOfProvinces } = RegionsHooks.useGetListProvinces();
  const { data: listOfDistrict } = RegionsHooks.useGetListDistricts({
    provinceCode,
  });

  const onSelectProvince = (value) => {
    const provCode = listOfProvinces.find((item) => {
      return item.name === value;
    }).code;
    setProvinceCode(provCode);
  };

  return (
    <Wrapper>
      <Divider />
      <div className="black1 font-subtitle2_medium">Contact Detail</div>
      <div className="component_contact_details_top">
        <Form.Item
          name="mobile_number"
          label="Phone Number"
          hasFeedback
          rules={[
            {
              required: true,
              message: commonMessage.required('phone number'),
            },
            {
              pattern: new RegExp(/^[0-9]{8,}\d*$/, 'g'),
              message: commonMessage.invalidType('phone number'),
            },
          ]}
          className="phone-number"
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="home_number"
          label="Home Number (Optional)"
          hasFeedback
          rules={[
            {
              pattern: new RegExp(/^[0-9]{5,}\d*$/, 'g'),
              message: 'Please check your home number',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="whatsapp_number"
          label="Whatsapp Number (Optional)"
          hasFeedback
          rules={[
            {
              pattern: new RegExp(/^[0-9]{5,}\d*$/, 'g'),
              message: 'Please check your whatsapp number',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item name="line_id" label="LINE ID (Optional)" hasFeedback>
          <Input />
        </Form.Item>
      </div>
      <div className="component_contact_details_two_columns">
        <Form.Item
          name="email_address_1"
          label="Email Address"
          hasFeedback
          rules={[
            {
              required: true,
              message: commonMessage.required('email address'),
            },
            {
              type: 'email',
              message: commonMessage.invalidType('email address'),
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="email_address_2"
          label="Alternative Email Address (Optional)"
          hasFeedback
          rules={[
            {
              type: 'email',
              message: commonMessage.invalidType('email address'),
            },
          ]}
        >
          <Input />
        </Form.Item>
      </div>
      <Divider />
      <div className="component_contact_details_streets">
        <div>
          <Form.Item
            name="address"
            label="Detail Address"
            hasFeedback
            rules={[
              {
                required: true,
                message: commonMessage.required('street address'),
              },
            ]}
          >
            <Input.TextArea />
          </Form.Item>
        </div>
        <div className="component_contact_details_location">
          <div className="component_contact_details_location_row">
            <Form.Item name="country" label="Country" hasFeedback>
              <Select placeholder="Choose Country">
                <Option value="indonesia">Indonesia</Option>
              </Select>
            </Form.Item>
            <Form.Item name="province_code" label="Province" hasFeedback>
              <Select
                placeholder="Choose Province"
                onSelect={(value) => {
                  onSelectProvince(value);
                }}
              >
                {listOfProvinces?.map((item) => {
                  return <Option value={item.name}>{item.name}</Option>;
                })}
              </Select>
            </Form.Item>
          </div>
          <div className="component_contact_details_location_row">
            <Form.Item name="district_code" label="City" hasFeedback>
              <Select placeholder="Choose City">
                {/* <Option value="indonesia">Indonesia</Option> */}
                {listOfDistrict?.map((item) => {
                  return (
                    <Option
                      value={item.name}
                      style={{ textTransform: 'capitalize' }}
                    >
                      {item.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item name="postal_code" label="Postal Code" hasFeedback>
              <Input />
            </Form.Item>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default Index;
